import React, { useState, createContext, useMemo } from "react";

export const CartContext = createContext();

export function CartProvider({ children }) {
  const [isCartOpen, setCartOpen] = useState(false);

  return (
    <CartContext.Provider
      value={useMemo(() => [isCartOpen, setCartOpen], [
        isCartOpen,
        setCartOpen,
      ])}
    >
      {children}
    </CartContext.Provider>
  );
}
